import { configureStore } from "@reduxjs/toolkit";
import dcoi from "../Reducers/dcoi";

export function makeStore(preloadedState) {
  return configureStore({
    reducer: {
      dcoi: dcoi.reducer,
    },
    devTools: true,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActionPaths: [
            'payload.headers',
            'payload.config',
            'payload.request',
            'meta.arg.image' // Add this line to ignore the non-serializable value
          ],
        },
      }),
  });
}

const store = makeStore();
export default store;
